import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { UserAvatar } from '@components/Feature/User/user-avatar';
import { useNavigate } from 'react-router-dom';
import { Form, Formik, FormikHelpers } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { object, string } from 'yup';
import { FormGroupControl } from '@components/Base';
import { ServerError } from '@components/Helper';
import { usernameSignIn, UsernameSignInPayload } from './action';
import { selectUsername } from './selector';
import { FormValues } from './type';

const UsernameCard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { errors } = useSelector(selectUsername);

  const initialValues: FormValues = {
    username: '',
    password: '',
  };

  const validationSchema = object({
    username: string().required(t('validation:required')),
    password: string().required(t('validation:required')),
  });

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    const payload: UsernameSignInPayload = values;
    dispatch(usernameSignIn(payload));
    setSubmitting(false);
  };

  return (
    <Card>
      <Card.Header className="text-center">
        <UserAvatar />
      </Card.Header>
      <Card.Body>
        <Card.Title>{t('registration.title')}</Card.Title>
        <Card.Text>{t('registration.title')}</Card.Text>
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form>
              <FormGroupControl name="username" label={t('user.username')} groupProps={{ className: 'mb-3' }} />

              <FormGroupControl
                type="password"
                name="password"
                label={t('common:password')}
                groupProps={{ className: 'mb-3' }}
              />

              <div className="d-grid gap-2">
                <Button type="submit" disabled={isSubmitting} variant="primary">
                  {t('common:signIn')}
                </Button>
                <Button variant="outline-secondary" onClick={() => navigate('-1')}>
                  {t('common:back')}
                </Button>
              </div>
              <ServerError errors={errors} />
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};

export { UsernameCard };
